import { render, staticRenderFns } from "./SuggestionView.vue?vue&type=template&id=ff97f17a&"
import script from "./SuggestionView.vue?vue&type=script&lang=js&"
export * from "./SuggestionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports